

module.exports = __webpack_require__.stylable.create(
    "Toast1959223108",
    {"classes":{"root":"Toast1959223108__root","content":"Toast1959223108__content","button":"Toast1959223108__button"},"vars":{},"stVars":{"SucessBG":"#57C487","BorderRadius":"2px","FontColor":"#fff","ErrorBG":"#F64D43"},"keyframes":{"fadeIn":"Toast1959223108__fadeIn"}},
    "",
    1,
    "Toast1959223108",
    null
);
